import { render, staticRenderFns } from "./ContactusContentMult.vue?vue&type=template&id=37fb1962&scoped=true"
import script from "./ContactusContentMult.vue?vue&type=script&lang=ts"
export * from "./ContactusContentMult.vue?vue&type=script&lang=ts"
import style0 from "./ContactusContentMult.vue?vue&type=style&index=0&id=37fb1962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fb1962",
  null
  
)

export default component.exports